import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    font-family: "Lato", sans-serif;
    box-sizing: border-box;
  }

  a {
    text-decoration: none;
    color: black;
  }
  
  :root {
    --background-color: #242424;
    --primary-text-color: #f9f0f0;
    --gold-highlight-color: #ffc97f;
    --green-highlight-color: #ebff70;
    --blue-highlight-color: #b0ffff;
    --red-highlight-color: #ff7070;
    --main-padding-mob: 6rem 2rem 0 2rem;
    --main-padding-tab: 6rem 10rem 0 10rem;
    --main-padding-pc: 6rem 35rem 0 35rem;
  }
  html {
    scroll-behavior: smooth;
  }
`

export default GlobalStyles;